import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import ReactQuill from 'react-quill';
import {quillConfig} from '../../../mock/quill-config';
import {useFormik} from 'formik';
import {createNewsSchema} from "../../../schema/newsSchema";
import {UploadImage} from "../../../components/common/uploadImage/UploadImage";
import {LANGUAGES} from "../../../mock/languages";
import {createNews} from "../../../services/newsSvc";
import {useNotification} from "../../../context/NotificationContext";
import {lang} from "../../../types/lang";
import {KTIcon} from "../../../../_metronic/helpers";
import {MyTooltip} from "../../../components/common/tooltip/Tooltip";
import {adjustColor} from "../../../utils/adjustColor";
import {colors} from "../../../mock/colors";
import {createCourseSchema} from "../../../schema/courseSchema";
import {createCourse} from "../../../services/courseSvc";
import { TELEGRAM_RESOURCES_URL } from '../../../mock/URLs';

export const CourseCreatePage = () => {
  const navigate = useNavigate();
  const {formatMessage} = useIntl();
  const {showNotification} = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: {
        uz: '',
        ru: '',
        en: '',
      },
      sub_title: {
        uz: '',
        ru: '',
        en: '',
      },
      description: {
        uz: '',
        ru: '',
        en: '',
      },
      image: null,
      first_color: "#51bc96",
      second_color: "#9bd8c3",
    },
    validationSchema: createCourseSchema,
    onSubmit: async (values, {
      resetForm
    }) => {
      const formData = new FormData();
      formData.append('title_uz', values.title.uz);
      formData.append('title_ru', values.title.ru);
      formData.append('title_en', values.title.en);
      formData.append('sub_title_uz', values.sub_title.uz);
      formData.append('sub_title_ru', values.sub_title.ru);
      formData.append('sub_title_en', values.sub_title.en);
      formData.append('description_uz', values.description.uz);
      formData.append('description_ru', values.description.ru);
      formData.append('description_en', values.description.en);
      formData.append('first_color', values.first_color);
      formData.append('second_color', values.second_color);

      if (values.image) {
        formData.append('image', values.image);
      }

      try {
        const res = await createCourse(formData);
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Kurs qo'shildi", "success")
          resetForm();
          setTimeout(() => {
            navigate(-1)
          }, 1000)
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error")
      }
    },
  });

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  return (
      <div className={"mb-10"}>
        <div className={"card"}>
          <div className="card-header">
            <h1 className="card-title">Kurs qo'shish</h1>
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              {LANGUAGES.map((lang) => (
                  <li className="nav-item" key={lang.key}>
                    <button
                        className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                        onClick={() => handleTabChange(lang.key)}
                    >
                      {lang.name}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
          <form
              className="form"
              onSubmit={formik.handleSubmit}
              encType="multipart/form-data"
          >
            <div className="card-body">
              <div id="kt_account_profile_details" className="collapse show">
                <div className="card-body p-9">
                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Kurs nomi
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Kurs nomi"
                        name={`title.${activeTab}`}
                        value={formik.values.title[activeTab]}
                        onChange={formik.handleChange}
                    />
                      {formik.touched.title?.[activeTab] && formik.errors.title?.[activeTab] && (
                          <div className="text-danger">{formik.errors.title[activeTab]}</div>
                      )}
                    </div>
                  </div>


                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Kurs haqida qisqacha
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Kurs haqida qisqacha"
                        name={`sub_title.${activeTab}`}
                        value={formik.values.sub_title[activeTab]}
                        onChange={formik.handleChange}
                    />
                      {formik.touched.sub_title?.[activeTab] && formik.errors.sub_title?.[activeTab] && (
                          <div className="text-danger">{formik.errors.sub_title[activeTab]}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label fw-bold fs-6">
                      <span className="required">Kurs haqida to'liqroq</span>
                    </label>
                    <div className="col-lg-8 fv-row">
                      <div className={"h-200px"}>
                        <ReactQuill
                            key={activeTab}
                            style={{
                              height: "150px",
                            }}
                            placeholder={"Kurs haqida to'liqroq"}
                            formats={quillConfig?.formats}
                            modules={quillConfig?.modules}
                            value={formik.values.description[activeTab]}
                            onChange={(value) =>
                                formik.setFieldValue(`description.${activeTab}`, value)
                            }
                        />
                      </div>
                      {formik.touched.description?.[activeTab] && formik.errors.description?.[activeTab] && (
                          <div className="text-danger">{formik.errors.description[activeTab]}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Banner rasmi
                    </label>
                    <div className="col-lg-8 fv-row">
                      <UploadImage imageSizes={"banner"} onImageUpload={(file) => {
                        if (file) {
                          formik.setFieldValue('image', file);
                        }
                      }}/>
                      {formik.touched.image && formik.errors.image && (
                          <div className="text-danger">{formik.errors.image}</div>
                      )}
                      <span className={"text-muted text-sm"}>
                      Ishlatish tavsiya etiladi:
                      <a href={TELEGRAM_RESOURCES_URL} target={"_blank"}> @bola_himoyasi_resources</a>
                    </span>
                    </div>
                  </div>
                </div>

                <div className="row mb-6">
                  <label className="col-lg-4 col-form-label required fw-bold fs-6">
                    Chap rang
                  </label>
                  <div className="col-lg-8 fv-row">
                    <input
                        type={"color"}
                        className="form-control form-control-lg form-control-solid"
                        name="first_color"
                        value={formik.values.first_color}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.first_color && formik.errors.first_color && (
                        <div className="text-danger">{formik.errors.first_color}</div>
                    )}
                  </div>
                </div>

                <div className="row mb-6">
                  <label className="col-lg-4 col-form-label required fw-bold fs-6">
                    O'ng rang
                  </label>
                  <div className="col-lg-8 d-flex align-items-stretch gap-2 fv-row">
                    <div className={"w-100"}>
                      <input
                          type={"color"}
                          className="form-control form-control-lg form-control-solid"
                          name="second_color"
                          value={formik.values.second_color}
                          onChange={formik.handleChange}
                      />
                      {formik.touched.second_color && formik.errors.second_color && (
                          <div className="text-danger">{formik.errors.second_color}</div>
                      )}
                    </div>
                    <div className={"h-100"}>
                      <MyTooltip title={"Tavsiya rang generatsiya qilish"} position={"top"}>
                        <button type="button"
                                onClick={
                                  () => {
                                    const color = adjustColor(formik.values.first_color, 80);
                                    formik.setFieldValue('second_color', color);
                                  }
                                }
                                className={"btn h-100 btn-icon btn-light-primary"}>
                          <KTIcon iconName={"arrows-circle"} className={"fs-2"}/>
                        </button>
                      </MyTooltip>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div className="card-footer">
              <div className="justify-content-end d-flex gap-2">
                <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                    type="button"
                >
                  {formatMessage({id: "Bekor qilish"})}
                </button>
                <button
                    className="btn btn-primary"
                    type="submit"
                >
                  {formatMessage({id: "Saqlash"})}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
  );
};